var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5476 9.21108H10.5287V12.3675H15.2206C15.1353 13.1353 14.6235 14.3296 13.5145 15.0973C12.832 15.6092 11.8083 15.9504 10.5287 15.9504C8.31067 15.9504 6.34858 14.5002 5.66612 12.3675C5.4955 11.8556 5.41019 11.2585 5.41019 10.6613C5.41019 10.0642 5.4955 9.467 5.66612 8.95516C5.75143 8.78454 5.75143 8.61392 5.83673 8.52862C6.60451 6.73715 8.39598 5.45753 10.5287 5.45753C12.1495 5.45753 13.1732 6.13999 13.8557 6.73715L16.2443 4.34852C14.7941 3.0689 12.832 2.21582 10.5287 2.21582C7.20166 2.21582 4.30119 4.0926 2.93626 6.90776C2.3391 8.10208 1.99787 9.3817 1.99787 10.7466C1.99787 12.1116 2.3391 13.3912 2.93626 14.5855C4.30119 17.4007 7.20166 19.2774 10.5287 19.2774C12.832 19.2774 14.7941 18.5097 16.159 17.23C17.7799 15.7798 18.7183 13.5618 18.7183 10.9172C18.7183 10.2348 18.6329 9.72293 18.5476 9.21108Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.2feefc52a38d3d011c17eb709110cb71.svg";
export { ForwardRef as ReactComponent };